import styles from './RegisterFormAttendance.module.css'

import { StateAttendance } from '../StateAttendance'
import { ComponentBriefingContext } from '../../context/ComponentBriefingContextProvider'
import { CreateBriefing } from '../FormBriefing'
import { useContext, useEffect, useState } from 'react'
import { formataDate, formatInDate } from '../../../../utils/formatDate'
import { SectionContainer } from '../../../../components/SectionContainer/SectionContainer'
import attendanceApi from '../../../../services/api/attendance'
import attendantApi from '../../../../services/api/attendant'
import { Proposta } from '../Proposta'
import { Divider, IconButton } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Atendimento } from '@/interfaces/AttendanceData'
import { Producao } from '../Producao'
import { Montagem } from '../Montagem'
import { Feedback } from '../Feedback'
import { useClient } from '@/contexts/ClientContext'
import { PropostaProvider } from '@/contexts/PropostaContext/context'

interface RegisterAttendanceProps {
  idBriefing?: number
  idAttendance: number
  createdAt?: Date | string
  statusEstado?: Atendimento['estado']
}

export function RegisterFormAttendance({
  idAttendance,
  createdAt,
  statusEstado,
}: RegisterAttendanceProps) {
  const [ativo, setAtivo] = useState<boolean>(false)
  const [spread, setSpread] = useState(ativo)
  const [tituloAtendimento, setTituloAtendimento] = useState<string | undefined>()

  const [attendantName, setAttendantName] = useState<string | undefined>()
  const [, setIdClient] = useState<number>(0)
  const [createAttendance, setCreatedAttendance] = useState<string>('')
  const [estadoFixo, setEstadoFixo] =
    useState<Atendimento['estado']>('Briefing')

  const [loading, setLoading] = useState<boolean>(true)
  const clienteContext = useClient();

  const [atendimento, setAtendimento] = useState<Atendimento>()

  const [arquivado, setArquivado] = useState<boolean>(atendimento?.arquivado ?? false);

  const [propostaAtivaId, setPropostaAtivaId] = useState<number | null>(null)

  function togglspread() {
    setSpread(!spread)
  }

  useEffect(() => {
    if (!idAttendance || !loading) return

    attendanceApi.getAttendance(idAttendance).then((response) => {
      if (response.status !== 200 || !response.data) {
        console.error('Houve um erro ao obter um atendimento: ' + response)
        return
      }

      const attendance = response.data
      console.log('att', attendance)

      setTituloAtendimento(attendance.titulo)
      setArquivado(attendance.arquivado);
      setPropostaAtivaId(attendance.propostaAtiva)

      const dataFormat = formatInDate(attendance.criadoEm)
      if (dataFormat) {
        setCreatedAttendance(dataFormat)
        setIdClient(attendance.cliente_id)
      }
      setEstadoFixo(attendance.estado)
      attendantApi.getAttendant(attendance.atendente_id).then((response) => {
        if (response.status !== 200 || !response.data) {
          console.error('Houve um erro ao obter um atendente: ' + response)
          return
        }

        setAttendantName(response.data.nome)
      })

      setLoading(false)
      setAtendimento(response.data)
    })
  }, [idAttendance, loading, clienteContext.client])

  useEffect(() => {
    setAtivo(clienteContext.client.atendimentoAtualId == idAttendance)
    setSpread(clienteContext.client.atendimentoAtualId == idAttendance)
  }, [clienteContext.client])

  useEffect(() => {
    if (atendimento) {
      setArquivado(atendimento.arquivado ?? false)
    }
  } , [atendimento])

  return (
    <ComponentBriefingContext>
      <SectionContainer disabled={arquivado}>
        <div
          className={
            ativo ? styles.register_form_open : styles.register_form_closed
          }
        >
          <div className={styles.state_attendance}>
            <StateAttendance
              id={idAttendance}
              titulo={tituloAtendimento}
              attendant={attendantName ?? ''}
              date={createAttendance}
              days={createdAt ? formataDate(createdAt).display : ''}
              statusDoEstado={statusEstado ?? 'Briefing'}
              estado={estadoFixo}
              onAlternar={(ativo) => setAtivo(!ativo)}
              onEstadoChange={(novoEstado) => setEstadoFixo(novoEstado)}
              ativo={ativo}
              arquivado={arquivado}
              onArquivarChange={(novoArquivado) => setArquivado(novoArquivado)}
            />
          </div>
          {
            ativo && (
              <>
                {estadoFixo === 'Briefing' && (
                  <div className={styles.create_briefing}>
                    <CreateBriefing state={true} idAtendimento={idAttendance} ativo={ativo}/>
                  </div>
                )}

                {estadoFixo === 'Proposta' && (
                  <div className={styles.proposta}>
                    <header className={styles.header_container}>
                      <div className={styles.icone_titulo}>
                        {estadoFixo ? (
                          <CheckCircleIcon className={styles.checked_briefing} />
                        ) : (
                          <RadioButtonUncheckedIcon
                            className={styles.unchecked_briefing}
                          />
                        )}

                        <h4>Proposta</h4>
                      </div>

                      <div className={styles.open_for_close}>
                        <IconButton onClick={togglspread}>
                          {spread ? (
                            <ExpandLessIcon fontSize='large' />
                          ) : (
                            <ExpandMoreIcon fontSize='large' />
                          )}
                        </IconButton>
                      </div>
                    </header>
                    <Divider />
                    {spread && (
                      <>
                        <PropostaProvider>
                          <Proposta idAtendimento={String(idAttendance)} propostaAtivaId={propostaAtivaId} />
                        </PropostaProvider>
                      </>
                    )}
                  </div>
                )}

                {['Produção', 'Medição', 'Projeto Técnico'].includes(estadoFixo) && (
                  <Producao idAtendimento={idAttendance} />
                )}

                {['Montagem'].includes(estadoFixo) && (
                  <Montagem idAtendimento={idAttendance} />
                )}

                {['Feedback', 'Venda Concluída'].includes(estadoFixo) && (
                  <Feedback idAtendimento={idAttendance} />
                )}
              </>
            )
          }
        </div>

      </SectionContainer>
    </ComponentBriefingContext>
  )
}
